'use strict'
import api from '@/api/api'
import notify from "@/utils/notify"

export default {
  async getZReports(params = {}) {
    const query = new URLSearchParams()
    if (params.page) query.set('page', params.page)
    if (params.per_page) query.set('per_page', params.per_page)
    if (params.search) query.set('search', params.search)
    if (params.user_id) query.set('user_id', params.user_id)
    if (params.store_id) query.set('store_id', params.store_id)
    if (params.from_date) query.set('from_date', params.from_date)
    if (params.to_date) query.set('to_date', params.to_date)

    const data = {
      method: 'get',
      url: `z-reports${query.toString() ? `?${query.toString()}` : ''}`,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      return response.data
    }
    return []
  },

  async getZReport(id) {
    const data = {
      method: 'get',
      url: 'z-report/' + id,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      return response.data
    }
  },

  async generateZReport(shiftId, json = {}) {
    const data = {
      method: 'post',
      url: `shift/${shiftId}/z-report`,
      body: json,
    }

    const response = await api.api(data)
    if (response.status === 201) {
      notify.alert.success('Z-Report generated successfully')
      return response.data
    }
  },
}
